import {interaction, pipe} from "@dimensiondev/onflow-sdk"
import {resolve as defaultResolve} from "@dimensiondev/onflow-sdk"
import {config, createSignableVoucher} from "@dimensiondev/onflow-sdk"

export const serialize = async (args = [], opts = {}) => {
  const resolveFunction = await config.first(
    ["sdk.resolve"],
    opts.resolve || defaultResolve
  )

  if (Array.isArray(args)) args = await pipe(interaction(), args)

  return JSON.stringify(
    createSignableVoucher(await resolveFunction(args)),
    null,
    2
  )
}
